/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, tier: NonNullable<unknown> }} Report_Partner_PlainInputs */



/**
* | output |
* | --- |
* | "Partner: {name} · {tier} · net amounts" |
*
* @param {Report_Partner_PlainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_partner_plain = /** @type {((inputs: Report_Partner_PlainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Partner_PlainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.tier} · Nettobeträge`)
	return /** @type {LocalizedString} */ (`Partner: ${i?.name} · ${i?.tier} · net amounts`)
});